import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Stock } from '../../../../app/shared/models/b2b/stock';
import { ProductInfo } from '../../../shared/models/b2b/productInfo';
import { Product } from '../../../shared/models/b2b/product';

@Component({
    selector: 'app-product-stock-info-tabs',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './product-stock-info-tabs.component.html',
})
export class ProductStockInfoTabsComponent implements OnChanges {
    @Input() inModal = false;
    @Input() item: Product = null;
    @Input() productMoreInfo: ProductInfo;
    @Input() productStock: Stock[];
    @Input() empresa: number;
    activeTab: number = 1;
    infoHTML: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.productStock) {
            this.productStock = changes.productStock.currentValue;
        }
        if (changes && changes.item) {
            this.item = changes.item.currentValue;
        }
        if (changes && changes.productMoreInfo && changes.productMoreInfo.currentValue) {
            this.productMoreInfo = changes.productMoreInfo.currentValue;
            this.infoHTML = this.productMoreInfo.descripcionHtml || '';
        }
        if (changes && changes.empresa) {
            this.empresa = changes.empresa.currentValue;
        }
        if (changes && changes.inModal) {
            this.inModal = !!changes.inModal.currentValue;
        }
    }
}
